import React from 'react';
import { Navigate } from 'react-router-dom';

const isAuthenticated = () => {
  return !!localStorage.getItem('accessToken') && !!localStorage.getItem('refreshToken') && !!localStorage.getItem('email');
};

export const PrivateRoute = ({ element: Element }) => {
  return isAuthenticated() ? <Element /> : <Navigate to="/" replace />;
};